import { ComponentProps } from "react";

import styles from "@components/cards/Card.module.css";
import CardBase from "@components/cards/CardBase";
import ToggleCheckbox from "@components/fields/ToggleCheckbox";
import Popover from "@components/popovers/Popover";
import PopoverItem from "@components/popovers/PopoverItem";
import useOpener from "@hooks/useOpener";

type Props = ComponentProps<typeof CardBase> & {
  checkboxProps?: ComponentProps<typeof ToggleCheckbox>;
  footerContent?: JSX.Element;
  popoverItems: ComponentProps<typeof PopoverItem>[];
};

const CarePlanCard = ({ body, checkboxProps, className, footerContent, popoverItems, ...cardBaseProps }: Props) => {
  const popoverOpener = useOpener();

  const classNames = [styles.carePlanCard];
  if (className) classNames.push(className);

  return (
    <CardBase
      body={
        <div>
          <div className="flex items-center gap-10">
            {checkboxProps && (
              <div className="ion-hide-lg-down">
                <ToggleCheckbox {...checkboxProps} disabled={false} />
              </div>
            )}
            <div className="full-width">{body}</div>
            {popoverItems.length > 0 && (
              <div className="ion-hide-lg-down">
                <Popover color="gray-150" icon="ellipsisV" isOpen={popoverOpener.isOpen} opener={popoverOpener}>
                  {popoverItems.map(item => (
                    <PopoverItem
                      {...item}
                      key={item.textKey}
                      onClick={event => {
                        if (item.onClick) item.onClick(event);
                        popoverOpener.close();
                      }}
                    />
                  ))}
                </Popover>
              </div>
            )}

            {checkboxProps && (
              <div className="ion-hide-lg-up">
                <ToggleCheckbox {...checkboxProps} disabled={false} />
              </div>
            )}
          </div>
          {footerContent}
        </div>
      }
      border={false}
      className={classNames.join(" ")}
      color="white"
      data-test="care-plan-card"
      rounding="small"
      {...cardBaseProps}
    />
  );
};

export default CarePlanCard;
